export default "__VITE_ASSET__C9XOHKq5__"